/**
 * Call-wide camera capture limits for the IVS video-call stack and related getUserMedia paths.
 * The important part for decode/encode cost is the **max** bound; tune `ideal` after profiling.
 */
export const IVS_VIDEO_CALL_CAMERA: MediaTrackConstraints = {
  /** Tighter max than 720p cuts decode / compositor memory (~hundreds of MB in Chrome with several videos). */
  width: { ideal: 426, max: 640 },
  height: { ideal: 240, max: 360 },
  frameRate: { min: 12, ideal: 15, max: 15 },
};
